import { Component } from "@angular/core";
import { DialogRef, ModalComponent } from "ngx-modialog";
import { BSModalContext } from "ngx-modialog/plugins/bootstrap";

export class CannotUnbridgeDialogContext extends BSModalContext {
}

@Component({
    template: require('./cannot-unbridge.component.html'),
    styles: [require('./cannot-unbridge.component.scss')],
})
export class TelegramCannotUnbridgeComponent implements ModalComponent<CannotUnbridgeDialogContext> {

    constructor(public dialog: DialogRef<CannotUnbridgeDialogContext>) {
    }
}
